<template>
    <div :class="{'element': true, 'error': errors.has(label), 'focused':focused, 'required': required }">
        <label :class="{'float': true, 'active': active}" :for="label">{{ label }}</label>
        <select v-if="list" v-validate="required" :data-vv-scope="scope" v-model="value" :id="label" :name="label"  @focus="focused = true" @blur="focused = false" @change="change" :class="{'chosen': value !==''}">
            <option disabled value="">{{ label }}</option>
            <option v-if="mode === 'trans'" v-for="item in list" :key="item" :value="item">{{ trans('filters.'+item) }}</option>
            <option v-if="mode === 'exact'" v-for="item in list" :key="item" :value="item">{{ item }}</option>
            <option v-if="mode === 'nested'" v-for="item in list" :key="item" :value="item.value">{{ item.label }}</option>
        </select>
        <span v-show="errors.has(scope+'.'+label)" class="error">{{ errors.first(scope+'.'+label) }}</span>
    </div>
</template>
<script type='text/babel'>
    import element from '../../element'

    export default {
        mixins: [element],
        props: {
            list: {default: false},
            mode: {default: 'exact'},
        },
        mounted(){
        },
        methods: {
            change() {
                this.$parent.$emit('change', {label:this.label, value:this.value})
            }
        }
    };
</script>
